import {css} from 'styled-components';

import {fonts} from '../../../../libs/shared/ui/src/styles/fontStyles';

export const emailStyle = css`
  color: ${(p) => p.theme.composerText};
  font-family: ${fonts.system};
  line-height: 1.4;
  font-size: 14px;
`;
